import { render, staticRenderFns } from "./BillingEventTable.vue?vue&type=template&id=ec2dbcbc&scoped=true"
import script from "./BillingEventTable.vue?vue&type=script&lang=js"
export * from "./BillingEventTable.vue?vue&type=script&lang=js"
import style0 from "./BillingEventTable.vue?vue&type=style&index=0&id=ec2dbcbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2dbcbc",
  null
  
)

export default component.exports